import React, { useState } from "react";
import toast from "react-hot-toast";
import PhoneInput from 'react-phone-number-input'
import { isValidPhoneNumber } from "react-phone-number-input";
import { employersApi } from "../../API/Api";
import Swal from "sweetalert2";

const HeroSection = () => {
  const [showModal, setShowModal] = useState(false);

  return (
    <section className="for-employee">
      <div className="overlay-employee container">
        <div className="row align-items-center justify-content-center">
          {/* Left content */}
          <div className="col-lg-6 mb-lg-5 mb-lg-0 d-flex align-items-center p-3">
            <div className="content-left text-center text-lg-start">
              <small className="tagline-highlight">Connect. Hire. Grow.</small>
              <h1>Talent solutions designed for today’s hiring challenges.</h1>
              <p>
                Talent solutions built for today’s fast-moving market. Helping
                you find, hire, and grow with confidence.
              </p>

              {/* Mobile button to open popup */}
              <button
                className="btn-find-talent d-lg-none mt-3 popup-button rounded-0"
                onClick={() => setShowModal(true)}
              >
                Find Talent
              </button>
            </div>
          </div>

          {/* Desktop Form (hidden on mobile) */}
          <div className="col-lg-6 d-none d-lg-flex justify-content-lg-end justify-content-center">
            <FormComponent />
          </div>
        </div>
      </div>

      {/* Popup Modal for Mobile */}
      {showModal && (
        <div className="modal-overlay">
          <div className="modal-content">
            <button
              className="close-btn employee-hero-btn"
              onClick={() => setShowModal(false)}
            >
              ✖
            </button>
            <FormComponent />
          </div>
        </div>
      )}
    </section>
  );
};

// 🔹 Extract form as separate component
const FormComponent = () => {
  const [formData, setFormData] = useState({
    fullname: "",
    companyname: "",
    phonenumber: "",
    workemail: "",
    position: "",
  });

  const [errors, setErrors] = useState({
    fullname: "",
    companyname: "",
    phonenumber: "",
    workemail: "",
    position: "",
  });

  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });

    // Clear error when user types
    setErrors({ ...errors, [name]: "" });
  };

  const handlePhoneChange = (value) => {
    setFormData({ ...formData, phonenumber: value });
    setErrors({ ...errors, phonenumber: "" });
  };

  const validateForm = () => {
    let valid = true;
    const newErrors = {};

    if (!formData.fullname.trim()) {
      newErrors.fullname = "Full Name is required";
      valid = false;
    }
    if (!formData.companyname.trim()) {
      newErrors.companyname = "Company Name is required";
      valid = false;
    }
    if (!formData.workemail.trim()) {
      newErrors.workemail = "Work Email is required";
      valid = false;
    } else if (!/\S+@\S+\.\S+/.test(formData.workemail)) {
      newErrors.workemail = "Invalid email format";
      valid = false;
    }
    if (!formData.phonenumber) {
  newErrors.phonenumber = "Phone Number is required";
  valid = false;
} else if (!isValidPhoneNumber(formData.phonenumber)) {
  newErrors.phonenumber = "Enter a valid phone number";
  valid = false;
} else {
  const digitsOnly = formData.phonenumber.replace(/\D/g, "");
  if (digitsOnly.length > 12) {
    newErrors.phonenumber = "Maximum 10 digits allowed";
    valid = false;
  }
}
    if (!formData.position) {
      newErrors.position = "Please select a Position";
      valid = false;
    }

    setErrors(newErrors);
    return valid;
  };



  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) return;

    setLoading(true);
    try {
      await employersApi.createEmployer(formData);

      Swal.fire({
        title: "Success!",
        text: "Your request has been submitted! ✅",
        icon: "success",
        confirmButtonColor: "#6f42c1",
      });

      // Reset form
      setFormData({
        fullname: "",
        companyname: "",
        phonenumber: "",
        workemail: "",
        position: "",
      });
      setErrors({});
    } catch (error) {
      console.error(error);
      Swal.fire({
        title: "Error",
        text: error.response?.data?.message || "Failed to submit. Try again.",
        icon: "error",
        confirmButtonColor: "#d33",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <form
        className="form-container-employee"
        onSubmit={handleSubmit}
        noValidate
      >
        {/* Full Name */}
        <div className="form-column">
          <label htmlFor="fullname">Full Name</label>
          <input
            type="text"
            id="fullname"
            name="fullname"
            className={`form-control-employee ${
              errors.fullname ? "is-invalid" : ""
            }`}
            value={formData.fullname}
            onChange={handleChange}
            style={{ backgroundColor: "#D9D9D9" }}
          />
          {errors.fullname && (
            <div className="invalid-feedback text-start">{errors.fullname}</div>
          )}
        </div>

        {/* Company Name */}
        <div className="form-column">
          <label htmlFor="companyname">Company Name</label>
          <input
            type="text"
            id="companyname"
            name="companyname"
            className={`form-control-employee ${
              errors.companyname ? "is-invalid" : ""
            }`}
            value={formData.companyname}
            onChange={handleChange}
            style={{ backgroundColor: "#D9D9D9" }}
          />
          {errors.companyname && (
            <div className="invalid-feedback text-start">
              {errors.companyname}
            </div>
          )}
        </div>

        {/* Phone Number */}
       <div className="form-column">
  <label htmlFor="phonenumber">Phone Number</label>

  <PhoneInput
    international
    defaultCountry="IN"
    value={formData.phonenumber}
    onChange={handlePhoneChange}
    className={`custom-phone-input ${
      errors.phonenumber ? "is-invalid" : ""
    }`}
    placeholder="Enter phone number"
  />

  {errors.phonenumber && (
    <small className="invalid-feedback text-start">
      {errors.phonenumber}
    </small>
  )}
</div>


        {/* Work Email */}
        <div className="form-column">
          <label htmlFor="workemail">Work Email Address</label>
          <input
            type="email"
            id="workemail"
            name="workemail"
            className={`form-control-employee ${
              errors.workemail ? "is-invalid" : ""
            }`}
            value={formData.workemail}
            onChange={handleChange}
            style={{ backgroundColor: "#D9D9D9" }}
          />
          {errors.workemail && (
            <small className="text-danger">{errors.workemail}</small>
          )}
        </div>

        {/* Position */}
        <div className="form-column pb-3">
          <label htmlFor="position">Position you are looking for</label>
          <select
            id="position"
            className="form-select-employee"
            name="position"
            style={{ backgroundColor: "#D9D9D9" }}
            value={formData.position}
            onChange={handleChange}
          >
            <option value="" disabled>
              Select Position
            </option>
            <option value="developer">Developer</option>
            <option value="designer">Designer</option>
            <option value="product_manager">Product Manager</option>
            <option value="qa">Quality Assurance</option>
            <option value="marketing">Marketing</option>
          </select>
          {errors.position && (
            <small className="text-danger">{errors.position}</small>
          )}
        </div>

        <button
          type="submit"
          className="btn-find-talent employee-hero-btn rounded-0"
          disabled={loading}
        >
          {loading ? "Submitting..." : "Find Talent"}
        </button>
      </form>
      <style jsx>
        {`
          .employee-hero-btn {
            display: block !important;
          }
        `}
      </style>
    </>
  );
};

export default HeroSection;
